module.exports = __webpack_public_path__ + "img/illustrator-drawing.fdfa6be6.svg";